import { useEffect } from 'react';
import { useParams } from 'react-router';
import { useSelector } from 'react-redux';
import { currentFormSelector, editFormLoadingSelector } from '../store/selectors/editForm';
import { getForm as getFormAction } from '../store/actions/form';
import { emptyForm } from '../constants/emtyForm';
import useFetchAction from './useFetchAction';

export default function useCurrentForm() {
  const { formId } = useParams();
  const [getForm] = useFetchAction(getFormAction);

  // form static (no get ) if url /demo
  const currentForm = useSelector(currentFormSelector);
  const form =
    formId === 'demo' && window && window.location.href.search('demo/preview') < 0
      ? emptyForm
      : currentForm;
  const loading = useSelector(editFormLoadingSelector);

  useEffect(() => {
    if ((!form && !loading) || (form && String(form.id) !== formId)) {
      getForm(formId);
    }
  }, [formId, form]);

  return [form, loading];
}
